import { render, staticRenderFns } from "./editableCell.vue?vue&type=template&id=5b8cf884&scoped=true"
import script from "./editableCell.vue?vue&type=script&lang=js"
export * from "./editableCell.vue?vue&type=script&lang=js"
import style0 from "./editableCell.vue?vue&type=style&index=0&id=5b8cf884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8cf884",
  null
  
)

export default component.exports